import React from "react";
import { createPortal } from "react-dom";

const variantMap = {
  success: "success",
  error: "danger",
  warning: "warning",
  info: "info",
};

function Toast({ toasts, onDismiss }) {
  if (!toasts.length) return null;

  const container = (
    <div
      className="position-fixed top-0 end-0 p-3"
      style={{ zIndex: 9999 }}
      aria-live="polite"
      aria-label="Notifications"
    >
      {toasts.map(({ id, message, type }) => (
        <div
          key={id}
          className={`alert alert-${variantMap[type] || "info"} alert-dismissible fade show shadow-sm`}
          role="alert"
        >
          {message}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => onDismiss(id)}
          />
        </div>
      ))}
    </div>
  );

  return createPortal(container, document.body);
}

export default Toast;
